import { z } from 'zod'

const lenientBoolean = z.union([z.boolean(), z.stringbool()])

export const SkillInsertHtmlArgsSchema = z.strictObject({
  html: z.string().trim().min(1),
  location: z.enum(['before', 'after', 'replace']).optional().default('replace'),
})

const SkillInsertCommentSchema = z.strictObject({
  paragraph_id: z.string().min(1),
  comment_text: z.string().trim().min(1),
  search_text: z.string().nullable().optional(),
})

export const SkillInsertCommentsArgsSchema = z.strictObject({
  comments: z.array(SkillInsertCommentSchema).min(1),
  selection_paragraph_ids: z.array(z.string().min(1)).optional(),
  resolve_document_wide: lenientBoolean.optional().default(true),
})

const SkillReplySchema = z.strictObject({
  comment_id: z.string().min(1),
  comment_text: z.string().trim().min(1),
})

export const SkillRepliesArgsSchema = z.strictObject({
  replies: z.array(SkillReplySchema).min(1),
})

export const GetSectionArgsSchema = z.strictObject({
  id: z.string().trim().min(1),
  use_html: lenientBoolean.optional().default(true),
  per_paragraph: lenientBoolean.optional().default(false),
})
